import { lesson17Activity1, lesson17Activity2, lesson17Activity3 } from './assignments'
import { WHITE_INITIAL_MOVE, BLACK_PIECE_SEARCH_KEY, WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE } from '../../utils/constants';
import { createChessboard } from '../../utils';

let lessonConfig = [
    {
        id: 0,
        previous: null,
        next: 4,
        video: {
            src: 'img/videos/lesson_17/1.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 1
        }
    },
    {
        id: 1,
        previous: 0,
        next: 4,
        audio: { src: 'img/audio/lesson_17/1.mp3', start: true, controls: false },
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: 'rnb1kbrn/ppp1pppp/2q5/8/8/2N5/PPPP1PPP/R1BQKBNR',
                resultFen: 'rnb1kbrn/ppp1pppp/2q5/1B6/8/2N5/PPPP1PPP/R1BQK1NR',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                magnusMessage: 'Oops! That doesn\'t pin the Queen to the King.',
                magnusWrongMessage: 'It\'s the absolute pin by the Bishop!',
                from: 'f1',
                to: 'b5',
                next: 2
            }),
            positionFen: 'rnb1kbrn/ppp1pppp/2q5/8/8/2N5/PPPP1PPP/R1BQKBNR w - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Make a move to pin opposite Queen to King.'
        }

    },
    {
        id: 2,
        previous: 0,
        next: 4,
        audio: { src: 'img/audio/lesson_17/2.mp3', start: true, controls: false },
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: 'r3k1nr/pp2qppp/n1pb4/3p4/3P4/5N2/PPP2PPP/RNBQ1RK1',
                resultFen: 'r3k1nr/pp2qppp/n1pb4/3p4/3P4/5N2/PPP2PPP/RNBQR1K1',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                magnusMessage: 'Oops! That doesn\'t pin the Queen to the King.',
                magnusWrongMessage: 'The Rook is the BEST pin.',
                from: 'f1',
                to: 'e1',
                next: 3
            }),
            positionFen: 'r3k1nr/pp2qppp/n1pb4/3p4/3P4/5N2/PPP2PPP/RNBQ1RK1 w - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Make the BEST move to pin the Black Queen to King.'
        }
    },
    {
        id: 3,
        previous: 0,
        next: 4,
        audio: { src: 'img/audio/lesson_17/3.mp3', start: true, controls: false },
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: 'r4rk1/ppp2qbp/2np2p1/4pp2/2P5/P1NP2P1/1P2PPBP/R2Q1RK1',
                resultFen: 'r4rk1/ppp2qbp/2np2p1/3Bpp2/2P5/P1NP2P1/1P2PP1P/R2Q1RK1',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                magnusMessage: 'Oops! That doesn\'t pin the Queen to the King.',
                magnusWrongMessage: 'It\'s the absolute pin by the Bishop!',
                from: 'g2',
                to: 'd5',
                next: 4
            }),
            positionFen: 'r4rk1/ppp2qbp/2np2p1/4pp2/2P5/P1NP2P1/1P2PPBP/R2Q1RK1 w - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Make a move to pin the Black Queen to King.'
        }
    },
    {
        id: 4,
        previous: 0,
        next: 8,
        video: {
            src: 'img/videos/lesson_17/2.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 5
        }
    },
    {
        id: 5,
        previous: 4,
        next: 8,
        audio: { src: 'img/audio/lesson_17/4.mp3', start: true, controls: false },
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '5nk1/2p2bp1/4pp1p/8/1R1R1P1P/6P1/5P2/6K1',
                resultFen: '5nk1/5bp1/4pp1p/2p5/1R1R1P1P/6P1/5P2/6K1',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                magnusMessage: 'That\'s not a Fork.',
                magnusWrongMessage: 'It\'s a Fork by the pawn!',
                from: 'c7',
                to: 'c5',
                next: 6
            }),
            positionFen: '5nk1/2p2bn1/4pp1p/8/1R1R1P1P/6P1/5P2/6K1 b - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Find a successful fork.'
        }
    },
    {
        id: 6,
        previous: 4,
        next: 8,
        audio: { src: 'img/audio/lesson_17/5.mp3', start: true, controls: false },
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '3r1rk1/1pp2pp1/p3pn1p/2q1n3/8/2PP2N1/PP1NQPPP/R2R2K1',
                resultFen: '3r1rk1/1pp2pp1/p3pn1p/2q1n3/3P4/2P3N1/PP1NQPPP/R2R2K1',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                magnusMessage: 'That\'s not a Fork.',
                magnusWrongMessage: 'It\'s a Fork by the pawn!',
                from: 'd3',
                to: 'd4',
                next: 7
            }),
            positionFen: '3r1rk1/1pp2pp1/p3pn1p/2q1n3/8/2PP2N1/PP1NQPPP/R2R2K1 w - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Find a successful fork.'
        }
    },
    {
        id: 7,
        previous: 4,
        next: 8,
        audio: { src: 'img/audio/lesson_17/6.mp3', start: true, controls: false },
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '6k1/1pp2ppp/p2p2q1/4n3/8/2PP4/PP3PPP/4QBK1',
                resultFen: '6k1/1pp2ppp/p2p2q1/8/8/2PP1n2/PP3PPP/4QBK1',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                magnusMessage: 'That\'s not a Fork.',
                magnusWrongMessage: 'It\' a Fork by the Knight!',
                from: 'e5',
                to: 'f3',
                next: 8
            }),
            positionFen: '6k1/1pp2ppp/p2p2q1/4n3/8/2PP4/PP3PPP/4QBK1 b - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Find a successful fork.'
        }
    },
    {
        id: 8,
        previous: 4,
        next: 12,
        video: {
            src: 'img/videos/lesson_17/3.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 9
        }
    },
    {
        id: 9,
        previous: 8,
        next: 12,
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: 'r2q1rk1/1ppb1p1p/p2p2p1/8/4Q3/2PP2P1/PP3P1P/2KR1B1R',
                resultFen: 'r2q1rk1/1pp2p1p/p1bp2p1/8/4Q3/2PP2P1/PP3P1P/2KR1B1R',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                magnusMessage: 'That\'s not a Skewer.',
                magnusWrongMessage: 'It\'s a Skewer by the Bishop!',
                from: 'd7',
                to: 'c6',
                next: 10
            }),
            positionFen: 'r2q1rk1/1ppb1p1p/p2p2p1/8/4Q3/2PP2P1/PP3P1P/2KR1B1R b - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Move a Black piece to skewer the White Queen and Rook.'
        }
    },
    {
        id: 10,
        previous: 8,
        next: 12,
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '4r3/1p1p1p1p/pn2k1p1/2p5/8/2PP4/PPB2PPP/5RK1',
                resultFen: '4r3/1p1p1p1p/pn2k1p1/2p5/8/2PP4/PPB2PPP/4R1K1',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                magnusMessage: 'That\'s not a Skewer.',
                magnusWrongMessage: 'It\'s a Skewer by the Rook!',
                from: 'f1',
                to: 'e1',
                next: 11
            }),
            positionFen: '4r3/1p1p1p1p/pn2k1p1/2p5/8/2PP4/PPB2PPP/5RK1 w - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Move a White piece to skewer the Black King and Rook.'
        }
    },
    {
        id: 11,
        previous: 8,
        next: 12,
        chessboard: {
            board: lesson17Activity3({
                showIndicators: { allSides: true },
                position: '2r4r/5pk1/8/1p6/1P6/5PP1/R2K4/3R4',
                resultFen: ['2r5/5pk1/8/1p6/1P6/5PP1/R2K3r/3R4', '2rr4/5pk1/8/1p6/1P6/5PP1/R2K4/3R4', '3r3r/5pk1/8/1p6/1P6/5PP1/R2K4/3R4'],
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                magnusMessage: 'That\'s not a Skewer.',
                magnusWrongMessage: 'It\'s a Skewer by the Rook!',
                from: 'h8',
                to: 'h2',
                next: 12
            }),
            positionFen: '2r4r/5pk1/8/1p6/1P6/5PP1/R2K4/3R4 b - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Move a Black piece to skewer the White King and Rook.'
        }
    },
    {
        id: 12,
        previous: 8,
        next: 18,
        video: {
            src: 'img/videos/lesson_17/4.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 13
        }
    },
    {
        id: 13,
        previous: 12,
        next: 18,
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '2r2k2/5p1p/5bpn/2p5/5P2/2P1Q1P1/5K2/3R4',
                resultFen: '2r2k2/5p1p/5bp1/2p5/5Pn1/2P1Q1P1/5K2/3R4',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                magnusMessage: 'Try Again!',
                magnusWrongMessage: 'It\'s a double attack by the Knight!',
                from: 'h6',
                to: 'g4',
                next: 14
            }),
            positionFen: '2r2k2/5p1p/5bpn/2p5/5P2/2P1Q1P1/5K2/3R4 b - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Move a Black piece to create a successful pin, skewer or fork.'
        }
    },
    {
        id: 14,
        previous: 12,
        next: 18,
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '2r2k2/5p1p/5bpn/2p5/5P2/4Q1PP/5K2/4R3',
                resultFen: '2r2k2/5p1p/6pn/2p5/3b1P2/4Q1PP/5K2/4R3',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                magnusMessage: 'Try Again!',
                magnusWrongMessage: 'It\'s an absolute pin attack by the Bishop!',
                from: 'f6',
                to: 'd4',
                next: 15
            }),
            positionFen: '2r2k2/5p1p/5bpn/2p5/5P2/4Q1PP/5K2/4R3 b - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Move a Black piece to create a successful pin, skewer or fork.'
        }
    },
    {
        id: 15,
        previous: 12,
        next: 18,
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '2r2k2/5p1p/5bpn/2p5/5P2/4Q1PP/4K3/3R4',
                resultFen: '4rk2/5p1p/5bpn/2p5/5P2/4Q1PP/4K3/3R4',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                magnusMessage: 'Try Again!',
                magnusWrongMessage: 'Rook to e8 is an absolute pin!',
                from: 'c8',
                to: 'e8',
                next: 16
            }),
            positionFen: '2r2k2/5p1p/5bpn/2p5/5P2/4Q1PP/4K3/3R4 b - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Move a Black piece to create a successful pin, skewer or fork.'
        }
    },
    {
        id: 16,
        previous: 12,
        next: 18,
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '2r5/5k1p/4qbp1/2p5/5P2/4Q1PP/6BK/3R4',
                resultFen: '2r5/5k1p/4qbp1/2pB4/5P2/4Q1PP/7K/3R4',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                magnusMessage: 'Try Again!',
                magnusWrongMessage: 'It\'s an absolute pin attack by the Bishop!',
                from: 'g2',
                to: 'd5',
                next: 17
            }),
            positionFen: '2r5/5k1p/4qbp1/2p5/5P2/4Q1PP/6BK/3R4 w - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Move a White piece to create a successful pin, skewer or fork.'
        }
    },
    {
        id: 17,
        previous: 12,
        next: 18,
        chessboard: {
            board: lesson17Activity1({
                showIndicators: { allSides: true },
                position: '2r5/5p1p/4qbk1/2p5/5PP1/4Q2P/6BK/3R4',
                resultFen: '2r5/5p1p/4qbk1/2p2P2/6P1/4Q2P/6BK/3R4',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                magnusMessage: 'Try Again!',
                magnusWrongMessage: 'The pawn can make a Royal Fork!',
                from: 'f4',
                to: 'f5',
                next: 18
            }),
            positionFen: '2r5/5p1p/4qbk1/2p5/5PP1/4Q2P/6BK/3R4 w - - 0 1'
        },
        directions: {
            data: '<b>DIRECTIONS</b><br/>Move a White piece to create a successful pin, skewer or fork.'
        }
    },
    {
        id: 18,
        previous: 12,
        next: 19,
        video: {
            src: 'img/videos/lesson_17/5.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 19
        }
    },
    {
        id: 19,
        previous: 18,
        next: 20,
        audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
        qa: {
            id: 0,
            question: 'Which pieces can create Pins?',
            answer: [
                'Kings',
                'Knights and pawns',
                'Queens, Rooks and Bishops',
                'Any piece'
            ],
            rightAnswer: 'Queens, Rooks and Bishops',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 20,
        previous: 18,
        next: 21,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 1,
            question: 'Which pieces can create Forks?',
            answer: [
                'Kings and Queens',
                'Knights and pawns',
                'Queens, Rooks and Bishops',
                'Any piece'
            ],
            rightAnswer: 'Knights and pawns',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 21,
        previous: 18,
        next: 22,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 2,
            question: 'What is a pin?',
            answer: [
                'A sneaky double attack',
                'A line of pawns on the diagonal',
                'Two pieces attacking one piece',
                'When no piece is captured'
            ],
            rightAnswer: 'A sneaky double attack',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 22,
        previous: 18,
        next: 23,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 3,
            question: 'In an absolute pin...',
            answer: [
                'The pinned piece can’t move',
                'A piece is pinned to the Queen',
                'Two pieces will be captured',
                'No piece is captured'
            ],
            rightAnswer: 'The pinned piece can’t move',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 23,
        previous: 18,
        next: 24,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 4,
            question: 'In a relative pin...',
            answer: [
                'A piece is pinned to the King',
                'The pawns are the pins',
                'It is illegal for the pinned piece to move',
                'It is not a good idea for the pinned piece to move'
            ],
            rightAnswer: 'It is not a good idea for the pinned piece to move',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 24,
        previous: 18,
        next: 25,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 5,
            question: 'What is this move called?',
            answer: [
                'Pin',
                'Skewer',
                'Fork',
                'Royal fork'
            ],
            chessboard: {
                board: lesson17Activity2({
                    showIndicators: true,
                    position: '3r2k1/1pp2p2/p1n3pp/3N1b1q/2P5/1P3N2/P4PPP/4RQK1',
                    resultFen: '3r2k1/1pp2p2/p1n2Npp/5b1q/2P5/1P3N2/P4PPP/4RQK1',
                    from: 'd5',
                    to: 'f6'
                }),
                hint: true
            },
            rightAnswer: 'Royal fork',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 25,
        previous: 18,
        next: 26,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 6,
            question: 'What move can Black make to create a skewer?',
            answer: [
                'Ra4-c4+',
                'Ra4-a1+',
                'Ra4xd4',
                'd5xe4 (en passant)'
            ],
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '8/8/8/3pP2k/r2P2pP/6P1/8/2K2R2'
                }),
                hint: true
            },
            rightAnswer: 'Ra4-a1+',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 26,
        previous: 18,
        next: 27,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 7,
            question: 'What tactic is the Bishop on e4 using?',
            answer: [
                'A skewer',
                'A fork',
                'An absolute pin',
                'A relative pin'
            ],
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '4r3/2p2ppk/6qp/8/4B2P/P1PQ2P1/1P2KP2/8',
                    assignmentClass: 'custom-sparepiece',
        from: "square-h7",
        to: "square-g8",
        offset: [3, 3, 9, 9],
                }),
                hint: true
            },
            rightAnswer: 'An absolute pin',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 27,
        previous: 18,
        next: 28,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 8,
            question: 'Which move creates a Royal Fork?',
            answer: [
                'Nd3-e5+',
                'Nd3-f4+',
                'Nh7-f8+',
                'Nh7-g5+'
            ],
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '8/3q1p1N/4k3/8/8/3N2P1/3K1P2/8'
                }),
                hint: true
            },
            rightAnswer: 'Nh7-f8+',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 28,
        previous: 18,
        next: 29,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 9,
            question: 'Which move creates a skewer?',
            answer: [
                'Bg7-h6',
                'Bg7-d4',
                'Bf7-d5',
                'Bf7-c4'
            ],
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '2rr2k1/5bbp/R5p1/8/8/4RNP1/4KP2/4N3'
                }),
                hint: true
            },
            rightAnswer: 'Bf7-c4',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'lg'
        }
    },
    {
        id: 29,
        previous: 18,
        next: null,
        audio: { src: null, stop: true },
        qa: {
            position: 'center',
            result: true,
            nextLesson: 'Lesson Eighteen',
            styleClass: 'xl'
        }
    }
];

let assets = [
    '/img/background_16.png',
    '/img/background_17.png',
    '/img/background_18.png'
];

let config = {
    config: lessonConfig,
    assets: assets
}

export default config;



// WEBPACK FOOTER //
// ./src/lessons/lesson_17/index.js